import Container from "@vfuk/core-container/";
import { ReactNode } from "react";
import styled from "styled-components";

type BannerProps = {
  children: ReactNode;
  backgroundImage: string;
};

const ContainerStyled = styled.div`
  & div {
    border-radius: 0;
  }
`;
const Banner = ({ backgroundImage, children }: BannerProps) => {
  return (
    <ContainerStyled>
      <Container
        id="bannerId"
        appearance="secondary"
        enableOverlay={false}
        paddingLevel={5}
        backgroundImage={{
          sm: {
            src: backgroundImage,
          },
        }}
      >
        {children}
      </Container>
    </ContainerStyled>
  );
};

export default Banner;
